import fetch from '@/config/fetch';

export const
    // 回单管理-供应商/结算部-列表
    receiptList = (data) => fetch('/platform/receiptManage/list', data, 'GET'),
    // 回单管理-供应商/结算部-新增/编辑
    receiptAddOrUpdate = (data) => fetch('/platform/receiptManage/addOrUpdate', data, 'POST'),
    // 回单管理-供应商/结算部-详情
    receiptDetails = (id) => fetch(`/platform/receiptManage/getDetail/${id}`, {}, 'GET'),
    // 回单管理-供应商/结算部-详情-委托车列表
    receiptFormSearch = (data) => fetch('/platform/receiptManage/getVehicleList', data, 'GET'),
    // 回单管理-供应商/结算部-提交
    receiptSubmit = (id) => fetch(`/platform/receiptManage/submitReceipt/${id}`, {}, 'GET'),
    // 回单管理-供应商/结算部-确认收单
    receiptConfirm = (data) => fetch('/platform/receiptManage/confirmReceipt', data, 'POST'),
    // 回单管理-供应商/结算部-删除
    receiptDelete = (id) => fetch(`/platform/receiptManage/delete/${id}`, {}, 'GET'),
    // 回单管理-结算部-跟踪进度
    receiptProgress = (data) => fetch('/platform/receiptManage/progressConfirm', data, 'POST'),
    // 回单管理-交单报表-列表
    receiptReportList = (data) => fetch('/platform/receiptManage/receiptReport', data, 'GET'),
    // 回单管理-交单报表-详情-列表
    receiptReportDetailList = (data) => fetch('/platform/receiptManage/receiptReportDetail', data, 'GET');
